export default {"src":"/_next/static/media/black-scale.dc8c46d4.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};